import { ReturnAssessmentGroupsSchema } from "@redotech/redo-return-core-common/return-assessments/assessment-schemas";

export const createGroup = {
  name: "createGroup" as const,

  input: ReturnAssessmentGroupsSchema.omit({ _id: true }),

  output: ReturnAssessmentGroupsSchema,
};
